export default {
  devices: {
    deviceRemoved: 'Device removed',
    deviceUpdated: 'Device updated',
    deviceAdded: 'Device added',
    devices: 'Devices',
    device: 'Device',
    deviceOwner: 'Device owner',
    refreshRate: 'Refresh rate',
    deviceCode: 'Device code',
    warningConfig: 'Warning config',
    emergencyCallAlarm: 'Emergency call alarm',
    fallingAlarm: 'Falling alarm',
    heartPulseAlarm: 'Heart pulse alarm',
    heartRateAlarm: 'Heart rate alarm',
    pulseRateAlarm: 'Pulse rate alarm',
    spo2Alarm: 'Spo2 alarm',
    temperatureAlarm: 'Temperature alarm'
  }
}
